import { render, staticRenderFns } from "./FormSelectItemGroup.vue?vue&type=template&id=574d0188&scoped=true&"
import script from "./FormSelectItemGroup.vue?vue&type=script&lang=js&"
export * from "./FormSelectItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormSelectItemGroup.vue?vue&type=style&index=0&id=574d0188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574d0188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('574d0188')) {
      api.createRecord('574d0188', component.options)
    } else {
      api.reload('574d0188', component.options)
    }
    module.hot.accept("./FormSelectItemGroup.vue?vue&type=template&id=574d0188&scoped=true&", function () {
      api.rerender('574d0188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/form-input/FormSelectItemGroup.vue"
export default component.exports